// src/componets/EtfHeatmap.js
import React, { useEffect, useRef, memo } from 'react';

function EtfHeatmap() {
  const container = useRef();

  useEffect(
    () => {
      const script = document.createElement("script");
      script.src = "https://s3.tradingview.com/external-embedding/embed-widget-etf-heatmap.js";
      script.type = "text/javascript";
      script.async = true;
      script.innerHTML = `
        {
          "dataSource": "AllUSEtf",
          "blockSize": "volume",
          "blockColor": "change",
          "grouping": "asset_class",
          "locale": "en",
          "symbolUrl": "",
          "colorTheme": "dark",
          "hasTopBar": false,
          "isDataSetEnabled": false,
          "isZoomEnabled": true,
          "hasSymbolTooltip": true,
          "isMonoSize": false,
          "width": "100%",
          "height": "100%"
        }`;
      
      let currentContainer = container.current;

      if (currentContainer) {
        const timeoutId = setTimeout(() => {
          currentContainer.appendChild(script);
        }, 100);

        return () => {
          clearTimeout(timeoutId);
          if (currentContainer) {
            currentContainer.innerHTML = "";
          }
        };
      }

      return () => {
        if (currentContainer) {
          currentContainer.innerHTML = "";
        }
      };
    }, []
  );

  return (
    <div className="tradingview-widget-container" ref={container}>
    </div>
  );
}

export default memo(EtfHeatmap);
